var e="system",o="dark",r="",c=[o,r,e];export{e as a,o as b,r as c,c as d};
